import { colors } from '@kcftech/design-tokens';
import type { KCFTheme } from 'styles/themes/KCFTheme';
import { LightTheme } from 'styles/themes/light';

export const DarkTheme: KCFTheme = {
    bodyBackgroundColor: colors.grey['1000'],
    backgroundColor: colors.grey['950'],
    backgroundColorActive: colors.grey['900'],
    shadeBackgroundColor: colors.grey['850'],
    secondaryBackgroundColor: colors.grey['950'],

    borderColor: colors.grey['900'],
    navColor: colors.grey['950'],
    navBorderColor: colors.grey['850'],
    primaryText: colors.grey['50'],
    secondaryText: colors.grey['400'],
    secondaryButton: colors.grey['900'],
    secondaryButtonHover: colors.grey['850'],
    cancelButton: colors.grey['900'],
    cancelButtonHover: colors.grey['850'],
    disabledText: colors.grey['500'],
    link: colors.bluecta['400'],
    linkShifted: colors.bluecta['600'],
    title: colors.common.white,

    // Form elements
    inputBorder: colors.grey['500'],
    filterRadioButton: colors.grey['850'],

    infoBox: colors.grey['950'],

    chartBackgroundColor: colors.grey['950'],
    chartPlotGridBackgroundColor: colors.grey['900'],

    // timeseries
    timeseriesBackgroundColor: colors.common.black,
    timeseriesAxisColor: colors.grey['400'],
    timeseriesGridColor: colors.grey['800'],
    timeseriesDrawerUnselectedColor: colors.grey['950'],
    timeseriesErrorBackgroundColor: colors.orange['900'],
    activityLineColor: colors.grey['900'],
    markerTableSelectedColor: colors.grey['850'],

    iconButtonBackgroundHover: colors.grey['850'],

    tabSelected: colors.grey['900'],

    successToastColor: colors.green['900'],
    errorToastColor: colors.red['900'],

    issueQueueButtonBackgroundColor: colors.grey['850'],

    kcfOnlyLozengeBackground: colors.grey['200'],
    kcfOnlyLozengeText: colors.common.black,

    // --- Inherited from LightTheme (now using design-tokens) ---
    activeBackgroundColor1: LightTheme.activeBackgroundColor1,
    activeBackgroundColor2: LightTheme.activeBackgroundColor2,
    primaryBoxShadow: LightTheme.primaryBoxShadow,
    modalBoxShadow: LightTheme.modalBoxShadow,
    menuBoxShadow: LightTheme.menuBoxShadow,
    deleteButton: LightTheme.deleteButton,
    deleteButtonHover: LightTheme.deleteButtonHover,
    warningButton: LightTheme.warningButton,
    warningButtonHover: LightTheme.warningButtonHover,
    inputBorderFocused: LightTheme.inputBorderFocused,
    inputBorderInvalid: LightTheme.inputBorderInvalid,
    inputBorderValid: LightTheme.inputBorderValid,
    assetCardReportBackgroundColor: LightTheme.assetCardReportBackgroundColor,
    workbenchHeader: LightTheme.workbenchHeader,
    workbenchHeaderButtonHover: LightTheme.workbenchHeaderButtonHover,
    treeviewIconColor: LightTheme.treeviewIconColor,
    notificationsCog: LightTheme.notificationsCog,
    notificationsHeaderText: LightTheme.notificationsHeaderText,
    tabsBottomBorder: LightTheme.tabsBottomBorder,
    popupText: LightTheme.popupText,
    popupBackgroundColor: LightTheme.popupBackgroundColor,
    iconColor: LightTheme.iconColor,
    hardwareStatusActionButtonBackground: LightTheme.hardwareStatusActionButtonBackground,
    hardwareStatusActionButtonBackgroundHover:
        LightTheme.hardwareStatusActionButtonBackgroundHover,
    criticalSeverity: LightTheme.criticalSeverity,
    alarmSeverity: LightTheme.alarmSeverity,
    warningSeverity: LightTheme.warningSeverity,
    timeseriesErrorIconColor: LightTheme.timeseriesErrorIconColor,

    // Dashboards
    dashboardAccentPrimary: colors.bluecta['500'],
    dashboardAxisText: colors.grey['300'],
};
